module.exports = __webpack_public_path__ + "static/img/al9.18f8aad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al9.jpg
// module id = Cvx9
// module chunks = 1